export function getLinePublicLabel(input: unknown): string {
  const normalize = (value: unknown) =>
    value == null ? "" : String(value).trim();

  const normalizeSearch = (value: unknown) =>
    normalize(value).normalize("NFC").toLocaleLowerCase("sv-SE");

  if (typeof input === "string" || typeof input === "number") {
    const value = normalize(input);

    if (normalizeSearch(value).includes("östgötapendeln")) {
      return "81";
    }

    return value;
  }

  const line: any = input ?? {};

  const nameCandidates = [
    line.LineName,
    line.Name,
    line.name,
    line.Designation,
    line.designation,
    line.Heading,
    line.heading,
    line.Description,
    line.description,
  ]
    .map(normalizeSearch)
    .filter(Boolean);

  // exception for östgötapendeln
  if (nameCandidates.some((n) => n.includes("östgötapendeln"))) {
    return "81";
  }

  const displayCandidates = [
    line.LineName,
    line.PublicLineNumber,
    line.LineNo,
    line.LineNumber,
    line.Designation,
    line.lineName,
    line.publicLineNumber,
    line.lineNo,
    line.lineNumber,
    line.designation,
    line.Name,
    line.name,
  ]
    .map(normalize)
    .filter(Boolean);

  const numericDisplay = displayCandidates.find((s) =>
    /^\d+[A-Za-z]?$/.test(s)
  );

  if (numericDisplay) return numericDisplay;

  if (displayCandidates[0]) return displayCandidates[0];

  return line.id == null ? "" : normalize(line.id);
}
